<template>
  <div class="match-bet text-center">
    <div v-if="matchBet.outcomes">
      <p
        class="match-outcome"
        :class="`outcome-${matchBet.outcomes.length}`"
        v-for="(outcome, index) in matchBet.outcomes"
        :key="index">
        <span v-if="outcome.value">
          <!-- {{ outcome.value | round }} -->
          {{ outcome.value }}
        </span>
        <span
          class="bet-special"
          v-else-if="outcome.valueSpecial">
          {{ outcome.valueSpecial }}
        </span>
        <span v-else>
          -
        </span>
      </p>
    </div>
    <span v-else>
      -
    </span>
  </div>
</template>

<script>
export default {
  name: 'MatchBet',
  props: {
    matchBet: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.match-bet {
  position: relative;
  float: left;
  height: 100%;
  width: 20%;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: $match-bet-vertical-line-width;
    background-color: $match-bet-vertical-line-color-back;
  }
}

.match-outcome {
  position: relative;
  float: left;
  width: 50%;
  height: 100%;
  font-size: 0.9375rem;

  &.outcome-3 { width: 33.33% !important; }
  &.outcome-4 { width: 25% !important; }
  &.outcome-5 { width: 20% !important; }
}

.bet-special {
  color: $color-important-special;
  font-weight: $font-weight-bold;
  font-size: 0.875rem;
}
</style>
